import { z } from "zod";
export const UpdateWebhookConfig = z.object({
    organizationPublicId: z.string(),
    publicId: z.string(),
    enabled: z.boolean(),
    url: z.string().url().max(500),
});
//# sourceMappingURL=webhook-config.update.js.map